<template>
  <svg width="10" height="12" viewBox="0 0 10 12" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3.5 0.559387C2.67157 0.559387 2 1.23096 2 2.05939V2.93585H0V9.43585C0 10.5404 0.89543 11.4359 2 11.4359H8C9.10457 11.4359 10 10.5404 10 9.43585V2.93585H8V2.05939C8 1.23096 7.32843 0.559387 6.5 0.559387H3.5ZM7 3.93585V5.05939H8V3.93585H9V9.43585C9 9.98814 8.55229 10.4359 8 10.4359H2C1.44772 10.4359 1 9.98814 1 9.43585V3.93585H2V5.05939H3V3.93585H7ZM7 2.93585V2.05939C7 1.78324 6.77614 1.55939 6.5 1.55939H3.5C3.22386 1.55939 3 1.78324 3 2.05939V2.93585H7Z"
    />
  </svg>
</template>

<script setup lang="ts">
defineProps<{
  class?: string;
}>();
</script>
